import { Box, HStack, Skeleton, VStack } from '@chakra-ui/react';

export const PromoCodeSkeleton = () => {
  return (
    <Box bg='green.G50' borderColor='green.G200' borderWidth='1px' borderRadius='8px' p='12px'>
      <HStack justifyContent='space-between' alignItems='center' w='100%'>
        <HStack spacing='12px' alignItems='center' flex='1'>
          <Skeleton
            borderRadius='50%'
            w='28px'
            h='28px'
            flexShrink={0}
            startColor='green.G200'
            endColor='green.G100'
          />
          <VStack spacing='2px' align='start' flex='1'>
            <Skeleton height='16px' width='120px' startColor='green.G200' endColor='green.G100' />
            <Skeleton height='12px' width='80px' startColor='green.G200' endColor='green.G100' />
          </VStack>
        </HStack>
        <Skeleton
          borderRadius='4px'
          w='20px'
          h='20px'
          startColor='green.G200'
          endColor='green.G100'
        />
      </HStack>
    </Box>
  );
};
